import { render, staticRenderFns } from "./languageConfigModal.vue?vue&type=template&id=4fcd5acc&scoped=true"
import script from "./languageConfigModal.vue?vue&type=script&lang=js"
export * from "./languageConfigModal.vue?vue&type=script&lang=js"
import style0 from "./languageConfigModal.vue?vue&type=style&index=0&id=4fcd5acc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fcd5acc",
  null
  
)

export default component.exports